
<template>
  <BreadCrumb PageTitle="Configuration" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <ConfigurationContent />
    </div>
  </div>
</template>

<script setup>
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ConfigurationContent from "../../components/Admin/Configuration/ConfigurationContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>